class EnrollmentBanner {
  constructor () {
    this.init()
  }

  init () {
    const banner = document.querySelector('.c-enrollmentBanner')
    if (banner === null) return false
    const openButton = banner.querySelector('.c-enrollmentBanner__openButton')
    const closeButton = banner.querySelector('.c-enrollmentBanner__closeButton')

    const hideBanner = () => banner.classList.remove('isOpen')

    const handleClosure = event => !banner.contains(event.target) && hideBanner()

    openButton.addEventListener('click', (e) => {
      e.preventDefault()
      banner.classList.add('isOpen')
    })

    closeButton.addEventListener('click', (e) => {
      e.preventDefault()
      banner.classList.remove('isOpen')
    })

    window.addEventListener('click', handleClosure)
    window.addEventListener('focusin', handleClosure)
  }
}

export default EnrollmentBanner
